export default __webpack_public_path__ + "static/media/OnlineConsults.0a28fefb.svg";